import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { StripeProvider } from './context/StripeContext';
import { initGA, trackPageView } from './lib/analytics';
import Header from './components/Header';
import Home from './components/Home';
import Pricing from './components/Pricing';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import EmailConfirmation from './components/EmailConfirmation';
import Slideshow from './components/Slideshow';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

// Initialize GA
initGA();

// Track page views
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <StripeProvider>
          <div className="min-h-screen flex flex-col">
            <Header />
            <PageViewTracker />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/login" element={<SignIn />} />
                <Route path="/register" element={<SignUp />} />
                <Route path="/email-confirmation" element={<EmailConfirmation />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/slideshow" element={<Slideshow />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </StripeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
